module.exports = __webpack_public_path__ + "public/img/lj.00c92993.png";